import { shade, tint } from 'polished';

const palette = color => {
	return {
		light: tint(0.96, color),
		tint2: tint(0.9, color),
		tint1: tint(0.5, color),
		base: color,
		shade1: shade(0.2, color),
		shade2: shade(0.5, color),
		dark: shade(0.75, color),
	};
};

export const colors = {
	brand: palette('#FE4A7D'),
	pink: palette('#FE4A7D'),
	teal: palette('#34BBB4'),
	yellow: palette('#FDCB6E'),
	red: palette('#e74c3c'),
	background: ['#FFFFFF', '#f5f7f9', '#E6E6E6'],
	foreground: ['#313648', '#4B5165', 'rgba(49,54,72,.6)'],
};

export const helpers = {
	shadow: 'box-shadow: 0 1px 5px 0 rgba(0,0,0,.15)',
	fit: 'position:absolute;top:0;right:0;bottom:0;left:0;',
	ratio11: '&:before{content:"";display:block;width:100%;padding-top:100%;}',
	ratio916: '&:before{content:"";display:block;width:100%;padding-top:calc(100% / 9 * 16);}',
};

export const sizes = ['5px', '10px', '20px', '30px', '60px', '140px'];

export const font = {
	size: '16px',
	body: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
	head: '"Titillium Web",sans-serif',
	import: 'https://fonts.googleapis.com/css2?family=Titillium+Web:wght@400;700&display=swap',
};

export const width = {
	min: 335,
	max: 1024,
	small: 768,
	medium: 1024,
};

export const media = {
	small: `@media (max-width:${width.small}px)`,
	medium: `@media (min-width:${width.small + 1}px) and (max-width:${width.medium}px)`,
	large: `@media (min-width:${width.medium + 1}px)`,
	notsmall: `@media (min-width:${width.small + 1}px)`,
	notmedium: `@media (max-width:${width.small}px) and (min-width:${width.medium + 1}px)`,
	notlarge: `@media (max-width:${width.medium}px)`,
};
